import logErrorsService from "common/api/services/logErrorsService";
import ErrorPage from "pages/ErrorPage/ErrorPage";
import NotFoundPage from "pages/NotFoundPage/NotFoundPage";
import { useEffect } from "react";
import { isRouteErrorResponse, useRouteError } from "react-router";

export default function RootBoundary() {
  const error = useRouteError();

  useEffect(() => {
    if (isRouteErrorResponse(error)) return;
    logErrorsService.write({
      // @ts-ignore
      message: error?.message,
      level: "error",
      // @ts-ignore
      context: [error?.stack],
    });
  }, []);

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return <NotFoundPage />;
    }
  }
  return <ErrorPage />;
}
